import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import HomepageTemplate from '../components/Homepage.js';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const FeatureCard = makeShortcode("FeatureCard");
const ArtDirection = makeShortcode("ArtDirection");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`What is Instana?`}</h2>
    <PageDescription mdxType="PageDescription">
      <p>{`Instana is a fully automated Application and Performance Monitoring (APM)
solution for cloud-native, multi-cloud, hybrid cloud, on premises, IBM Z® and
more. With a single agent, Instana automatically discovers application building
blocks, traces every request and creates a dynamic graph of all dependencies. See more at IBM’s `}<a parentName="p" {...{
          "href": "https://www.ibm.com/cloud/instana?utm_content=SRCWW&p1=Search&p4=43700064490746231&p5=p&gclid=EAIaIQobChMI5vXN1su8-AIV1ODICh2eUA2SEAAYASAAEgLBLvD_BwE&gclsrc=aw.ds"
        }}>{`Instana Website`}</a>{`.`}</p>
    </PageDescription>
    <FeatureCard color="dark" href="/SalesEnablement/sales" title="What is Instana" actionIcon="arrowRight" className="homepage-feature" mdxType="FeatureCard">
      <ArtDirection mdxType="ArtDirection">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.09722222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABkUlEQVQoz0WPS28TQRCE92fDAfErcoEb4gZcUBDKJQhbsLaJCY8oCVKQE8eR147t3ZmemZ5+zAzaWMCnUqvq1FXVcHyCke63bWcAI+3liQNx/CtiIZZIjEidsYgxCiNR9W40/I3N59Ozj6Pv9dfzenpW/7h8MZ8fNisWFU2saW8CUtuZzkJnnfU+MleD6SllbY0F550PFrwB3xizcz4S7SWq/ICI5pRTSqqaUqqGkyk431oDiMjCSUlktVqDBYzRh0DMotoZYwCoD9LnlPrP9cm30pMmS355gZ3XIuIwWucxhFJKfsCHGBBLTpdben0F3DeS6riulwKD9a8Pdz8/NbPx+mrHISzuXNtq+Q+EaLxVjiGKY005kUj16vjozcXg0duDJ++fPT16/vjw4Nysy3ii1zPNWQMKRiEOSDvrHHBwhI48UCSuhqMv2/v1YjZf3tzezm4W13PvkZpVWDaxM2GzCZtNBEBiAwDgjXVtZy34EKmqp/1mTelfQ9WkOadSUimai/Y3i2o/veSUc+9KIZY/QrT4jxNy18gAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "instana",
            "title": "instana",
            "src": "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/3cbba/instana.png",
            "srcSet": ["/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/7fc1e/instana.png 288w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/a5df1/instana.png 576w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/3cbba/instana.png 1152w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/edda9/instana.png 1297w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.09722222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABkUlEQVQoz0WPS28TQRCE92fDAfErcoEb4gZcUBDKJQhbsLaJCY8oCVKQE8eR147t3ZmemZ5+zAzaWMCnUqvq1FXVcHyCke63bWcAI+3liQNx/CtiIZZIjEidsYgxCiNR9W40/I3N59Ozj6Pv9dfzenpW/7h8MZ8fNisWFU2saW8CUtuZzkJnnfU+MleD6SllbY0F550PFrwB3xizcz4S7SWq/ICI5pRTSqqaUqqGkyk431oDiMjCSUlktVqDBYzRh0DMotoZYwCoD9LnlPrP9cm30pMmS355gZ3XIuIwWucxhFJKfsCHGBBLTpdben0F3DeS6riulwKD9a8Pdz8/NbPx+mrHISzuXNtq+Q+EaLxVjiGKY005kUj16vjozcXg0duDJ++fPT16/vjw4Nysy3ii1zPNWQMKRiEOSDvrHHBwhI48UCSuhqMv2/v1YjZf3tzezm4W13PvkZpVWDaxM2GzCZtNBEBiAwDgjXVtZy34EKmqp/1mTelfQ9WkOadSUimai/Y3i2o/veSUc+9KIZY/QrT4jxNy18gAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "instana",
            "title": "instana",
            "src": "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/3cbba/instana.png",
            "srcSet": ["/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/7fc1e/instana.png 288w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/a5df1/instana.png 576w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/3cbba/instana.png 1152w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/edda9/instana.png 1297w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.09722222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABkUlEQVQoz0WPS28TQRCE92fDAfErcoEb4gZcUBDKJQhbsLaJCY8oCVKQE8eR147t3ZmemZ5+zAzaWMCnUqvq1FXVcHyCke63bWcAI+3liQNx/CtiIZZIjEidsYgxCiNR9W40/I3N59Ozj6Pv9dfzenpW/7h8MZ8fNisWFU2saW8CUtuZzkJnnfU+MleD6SllbY0F550PFrwB3xizcz4S7SWq/ICI5pRTSqqaUqqGkyk431oDiMjCSUlktVqDBYzRh0DMotoZYwCoD9LnlPrP9cm30pMmS355gZ3XIuIwWucxhFJKfsCHGBBLTpdben0F3DeS6riulwKD9a8Pdz8/NbPx+mrHISzuXNtq+Q+EaLxVjiGKY005kUj16vjozcXg0duDJ++fPT16/vjw4Nysy3ii1zPNWQMKRiEOSDvrHHBwhI48UCSuhqMv2/v1YjZf3tzezm4W13PvkZpVWDaxM2GzCZtNBEBiAwDgjXVtZy34EKmqp/1mTelfQ9WkOadSUimai/Y3i2o/veSUc+9KIZY/QrT4jxNy18gAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "instana",
            "title": "instana",
            "src": "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/3cbba/instana.png",
            "srcSet": ["/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/7fc1e/instana.png 288w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/a5df1/instana.png 576w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/3cbba/instana.png 1152w", "/Instana-1-Day-Partner-Workshop/static/eb2645142fe126663bd7eb808b33689e/edda9/instana.png 1297w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ArtDirection>
    </FeatureCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      